export default __webpack_public_path__ + "static/media/img_girl_a.44713b10.svg";